import { TriadLocaleMaster } from '../../models/locale-master.type';

export const defaultLocale: TriadLocaleMaster = {
  common: {
    copyright: '',
  },
} as const;
